'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: 10px;\n'], ['\n  margin-bottom: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  min-width: 100px;\n  min-height: 40px;\n  display: block;\n  vertical-align: middle;\n  margin: 5px 0px 5px 0px;\n  border: 1px solid #715AFF;\n  border-radius: 5px;\n  padding: 0 1em;\n  cursor: pointer;\n\n  h5 {\n    display: flex;\n    justify-content: space-between;\n    color: #715AFF;\n  }\n'], ['\n  min-width: 100px;\n  min-height: 40px;\n  display: block;\n  vertical-align: middle;\n  margin: 5px 0px 5px 0px;\n  border: 1px solid #715AFF;\n  border-radius: 5px;\n  padding: 0 1em;\n  cursor: pointer;\n\n  h5 {\n    display: flex;\n    justify-content: space-between;\n    color: #715AFF;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #000;\n'], ['\n  color: #000;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: #403788 !important;\n  border: 1px solid #715AFF !important;\n  h5 {\n    color: #FFF !important;\n  }\n  span {\n    color: #FFF !important;\n  }\n'], ['\n  background-color: #403788 !important;\n  border: 1px solid #715AFF !important;\n  h5 {\n    color: #FFF !important;\n  }\n  span {\n    color: #FFF !important;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  border: 1px solid red;\n'], ['\n  border: 1px solid red;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SideTabWrapper = _styledComponents2.default.div(_templateObject);

var SideTabContainer = _styledComponents2.default.div(_templateObject2);

var Content = _styledComponents2.default.span(_templateObject3);

var SideTabContainerSelected = SideTabContainer.extend(_templateObject4);

var SideTabContainerError = SideTabContainer.extend(_templateObject5);

var MozartSideTab = function (_Component) {
  _inherits(MozartSideTab, _Component);

  function MozartSideTab() {
    _classCallCheck(this, MozartSideTab);

    return _possibleConstructorReturn(this, (MozartSideTab.__proto__ || Object.getPrototypeOf(MozartSideTab)).apply(this, arguments));
  }

  _createClass(MozartSideTab, [{
    key: 'getTab',
    value: function getTab() {
      var _props = this.props,
          selected = _props.selected,
          error = _props.error,
          data = _props.data;

      var DATA = _react2.default.createElement(
        'h5',
        null,
        _react2.default.createElement(
          Content,
          null,
          data
        ),
        _react2.default.createElement('span', { className: 'icon-Right' })
      );

      if (selected) {
        return _react2.default.createElement(
          SideTabContainerSelected,
          null,
          DATA
        );
      }
      if (error) {
        return _react2.default.createElement(
          SideTabContainerError,
          null,
          DATA
        );
      }
      return _react2.default.createElement(
        SideTabContainer,
        null,
        DATA
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          handleClick = _props2.handleClick,
          themeId = _props2.themeId;

      return _react2.default.createElement(
        SideTabWrapper,
        { 'data-qa': this.props.testId, id: id, onClick: handleClick ? handleClick.bind(this) : undefined, 'data-theme': themeId },
        this.getTab()
      );
    }
  }]);

  return MozartSideTab;
}(_react.Component);

MozartSideTab.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  id: _propTypes2.default.string,
  handleClick: _propTypes2.default.func,
  data: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  error: _propTypes2.default.bool
};
MozartSideTab.defaultProps = {
  testId: 'MozartSideTab',
  themeId: 'MozartSideTab'
};
exports.default = MozartSideTab;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartSideTab/MozartSideTab.js
// module id = 1829
// module chunks = 1